import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Table, Badge as BsBadge, Button, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { DUYET_HOSO_TUYENSINH_API } from '@app/utils/apiUrl';
import { ACCOUNT_API } from '../../../../../utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    trangThaiHoSoDuTuyenValue,
    objectTrangThaiHoSoDuTuyen,
    objectShowNumber
} from '../../../../../utils/define';
import DuyetHoSoTuyenSinhDetailModal from './DuyetHoSoTuyenSinhDetailModal';
import ChamDiemDeCuongModalWrapper from '../../tuyenSinhTienSi/chiTietKetQuaNCS/ChamDiemDeCuongModalWrapper';

const DuyetHoSoTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [trangThaiFilter, setTrangThaiFilter] = useState('');
    const [cccdMap, setCccdMap] = useState({});
    
    // Modal states
    const [showDetail, setShowDetail] = useState(false);
    const [selectedHoSoId, setSelectedHoSoId] = useState(null);

    const [showChamDiemModal, setShowChamDiemModal] = useState(false);
    const [selectedHoSoIdChamDiem, setSelectedHoSoIdChamDiem] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionType, setActionType] = useState(null);
    const [ghiChuChinhSua, setGhiChuChinhSua] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DUYET_HOSOTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['duyetHoSoTuyenSinh', valueSearch, page, pageSize, trangThaiFilter],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                TrangThaiHoSoDuTuyens: trangThaiFilter ? [Number(trangThaiFilter)] : [1, 2, 3, 4] // Lọc các hồ sơ đã gửi đi
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(DUYET_HOSO_TUYENSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, trangThaiFilter]);

    useEffect(() => {
        const fetchCCCDs = async () => {
            if (!data?.data) return;
            const itemsToFetch = data?.data?.$values || data?.data || [];
            if (itemsToFetch.length === 0) return;
            
            const newCccdMap = { ...cccdMap };
            let changed = false;
            
            for (const app of itemsToFetch) {
                const accId = app.accountId || app.AccountId;
                if (accId && !newCccdMap[accId]) {
                    try {
                        const res = await Get(ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG, accId, null);
                        const fetchedUsername = res?.account?.username || res?.Account?.Username || res?.identityCardNumber || res?.IdentityCardNumber;
                        if (fetchedUsername) {
                            newCccdMap[accId] = fetchedUsername;
                            changed = true;
                        }
                    } catch (e) {
                        console.error('Lỗi khi lấy thông tin CCCD:', e);
                    }
                }
            }
            if (changed) {
                setCccdMap(newCccdMap);
            }
        };
        fetchCCCDs();
    }, [data]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const handleViewDetail = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setShowDetail(true);
    };

    const handleOpenChamDiem = (app) => {
        setSelectedHoSoIdChamDiem(app.id || app.Id);
        setShowChamDiemModal(true);
    };

    const handleOpenConfirm = (app, actionId) => {
        setSelectedHoSoId(app.id || app.Id);
        setActionType(actionId);
        setGhiChuChinhSua('');
        setShowConfirmModal(true);
    };

    const handleDuyet = async () => {
        if (!ghiChuChinhSua && (actionType === 2 || actionType === 4)) {
            toast.warning('Vui lòng nhập ghi chú / lý do để gửi tới người dùng!');
            return;
        }

        setSubmitting(true);
        try {
            const result = await Put(DUYET_HOSO_TUYENSINH_API.DUYET_HO_SO, selectedHoSoId, {
                Action: actionType,
                GhiChuChinhSua: ghiChuChinhSua
            });

            if (result && result.ok) {
                toast.success('Duyệt hồ sơ thành công!');
                setShowConfirmModal(false);
                setSelectedHoSoId(null);
                refetch();
            } else {
                toast.error(result?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (e) {
            toast.error('Lỗi kết nối máy chủ!');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Danh sách duyệt hồ sơ tuyển sinh</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="d-flex mb-3">
                        <div style={{ width: '250px' }}>
                            <Form.Control
                                as="select"
                                value={trangThaiFilter}
                                onChange={(e) => { setTrangThaiFilter(e.target.value); setPage(1); }}
                            >
                                <option value="">Tất cả (đã gửi)</option>
                                <option value={trangThaiHoSoDuTuyenValue.choDuyet}>Chờ duyệt</option>
                                <option value={trangThaiHoSoDuTuyenValue.duyet}>Đã duyệt</option>
                                <option value={trangThaiHoSoDuTuyenValue.tuChoi}>Từ chối</option>
                                <option value={trangThaiHoSoDuTuyenValue.canChinhSua}>Cần chỉnh sửa</option>
                            </Form.Control>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Số hồ sơ</th>
                                    <th>Số CCCD</th>
                                    <th>Người nộp</th>
                                    <th>Đợt tuyển sinh</th>
                                    <th>Ngày nộp</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th className="text-center" style={{ width: '120px' }}>Thao tác</th>
                                    <th className="text-center" style={{ width: '100px' }}>Chấm điểm</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={9}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={9}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={9}>Không có hồ sơ nào.</td>
                                    </tr>
                                ) : (
                                    items.map((app, idx) => {
                                        const statusValue = app.trangThaiHoSoDuTuyen ?? app.TrangThaiHoSoDuTuyen;
                                        const statusLabel = getLabelFromEnum(statusValue, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue);
                                        const isChoDuyet = statusLabel === 'Chờ duyệt' || Number(statusValue) === 1;
                                        const cDate = app.createdDate || app.CreatedDate;
                                        const dateStr = cDate ? moment(cDate).format('DD/MM/YYYY HH:mm') : '';
                                        return (
                                            <tr key={app.id || idx}>
                                                <td>{(page - 1) * pageSize + idx + 1}</td>
                                                <td>{app.soHoSo || app.SoHoSo || 'Chưa cấp'}</td>
                                                <td>{cccdMap[app.accountId || app.AccountId] || 'Đang tải...'}</td>
                                                <td>{app.hoTen || app.HoTen}</td>
                                                <td>{app.tenDotTuyenSinh || app.TenDotTuyenSinh}</td>
                                                <td>{dateStr}</td>
                                                <td className="text-center">
                                                    <BsBadge 
                                                        variant={
                                                            statusLabel === 'Duyệt' ? 'success' :
                                                            statusLabel === 'Từ chối' ? 'danger' :
                                                            statusLabel === 'Cần chỉnh sửa' ? 'warning' : 'info'
                                                        } 
                                                        className="px-2 py-1"
                                                    >
                                                        {statusLabel}
                                                    </BsBadge>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center">
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view-${idx}`}>Kiểm tra hồ sơ</Tooltip>}>
                                                            <Button variant="outline-primary" size="sm" className="mr-1" onClick={() => handleViewDetail(app)}>
                                                                <i className="fa fa-eye"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-approve-${idx}`}>Duyệt</Tooltip>}>
                                                            <Button variant="outline-success" size="sm" className="mr-1" onClick={() => handleOpenConfirm(app, 3)}>
                                                                <i className="fa fa-check"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-edit-${idx}`}>Yêu cầu chỉnh sửa</Tooltip>}>
                                                            <Button variant="outline-warning" size="sm" className="mr-1" onClick={() => handleOpenConfirm(app, 2)}>
                                                                <i className="fa fa-edit"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-reject-${idx}`}>Từ chối</Tooltip>}>
                                                            <Button variant="outline-danger" size="sm" onClick={() => handleOpenConfirm(app, 4)}>
                                                                <i className="fa fa-times"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <Button variant="outline-info" size="sm" onClick={() => handleOpenChamDiem(app)}>
                                                        <i className="fa fa-star"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {showDetail && (
                <DuyetHoSoTuyenSinhDetailModal 
                    show={showDetail} 
                    handleClose={() => {
                        setShowDetail(false);
                        setSelectedHoSoId(null);
                        refetch();
                    }} 
                    hoSoId={selectedHoSoId} 
                />
            )}

            {showChamDiemModal && (
                <ChamDiemDeCuongModalWrapper
                    show={showChamDiemModal}
                    handleClose={() => {
                        setShowChamDiemModal(false);
                        setSelectedHoSoIdChamDiem(null);
                    }}
                    hoSoId={selectedHoSoIdChamDiem}
                />
            )}

            {/* Confirm Modal for Từ chối / Cần chỉnh sửa */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} backdrop="static" style={{ zIndex: 10000 }} centered>
                <Modal.Header closeButton className={actionType === 4 ? 'bg-danger text-white' : actionType === 3 ? 'bg-success text-white' : 'bg-warning text-white'}>
                    <Modal.Title>{actionType === 4 ? 'Từ chối hồ sơ' : actionType === 3 ? 'Duyệt hồ sơ' : 'Yêu cầu chỉnh sửa hồ sơ'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {actionType === 3 && (
                        <p className="mb-3 text-success font-weight-bold">Bạn có chắc chắn muốn DUYỆT hồ sơ này?</p>
                    )}
                    <Form.Group>
                        <Form.Label className="font-weight-bold">
                            Ghi chú / Lý do {(actionType === 2 || actionType === 4) && <span className="text-danger">*</span>}
                        </Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={4} 
                            placeholder={actionType === 3 ? "Nhập ghi chú (không bắt buộc)..." : "Nhập ghi chú hoặc lý do cho ứng viên..."}
                            value={ghiChuChinhSua} 
                            onChange={(e) => setGhiChuChinhSua(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Hủy</Button>
                    <Button 
                        variant={actionType === 4 ? 'danger' : actionType === 3 ? 'success' : 'warning'} 
                        className={(actionType === 2 || actionType === 3) ? 'text-white' : ''}
                        disabled={submitting} 
                        onClick={() => handleDuyet()}
                    >
                        {submitting ? 'Đang xử lý...' : 'Xác nhận'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DuyetHoSoTuyenSinh;
